var map = {
	"./afb-color.svg": 1682,
	"./afb.svg": 1683,
	"./alb-color.svg": 1684,
	"./alb.svg": 1685,
	"./amb-color.svg": 1686,
	"./amb.svg": 1687,
	"./bbbaidja-color.svg": 1688,
	"./bbbaidjaxxx-color.svg": 1689,
	"./bdinidjaxxx-color.svg": 1690,
	"./bimb-color.svg": 1691,
	"./bimb.svg": 1692,
	"./bkr-color.svg": 1693,
	"./bkr.svg": 1694,
	"./bmriidja-color.svg": 1695,
	"./bniaidja-color.svg": 1696,
	"./bninidja-color.svg": 1697,
	"./bninidjaxxx-color.svg": 1698,
	"./bpay-color.svg": 1699,
	"./brinidja002-color.svg": 1700,
	"./bsmdidjaxxx-color.svg": 1701,
	"./bsn-color.svg": 1702,
	"./bsn.svg": 1703,
	"./btanidjaxxx-color.svg": 1704,
	"./cenaidja-color.svg": 1705,
	"./cenaidjaxxx-color.svg": 1706,
	"./cimb-color.svg": 1707,
	"./cimb.svg": 1708,
	"./citi-color.svg": 1709,
	"./citi.svg": 1710,
	"./default-bank-icon-color.png": 1711,
	"./default-bank-icon.png": 1712,
	"./gxbank-color.svg": 1713,
	"./hlb-color.svg": 1714,
	"./hlb.svg": 1715,
	"./hsbc-color.svg": 1716,
	"./hsbc.svg": 1717,
	"./ibbkidjaxxx-color.svg": 1718,
	"./kwh-color.svg": 1719,
	"./kwh.svg": 1720,
	"./mbb-color.svg": 1721,
	"./mbb.svg": 1722,
	"./nispidjaxxx-color.svg": 1723,
	"./ocbc-color.svg": 1724,
	"./ocbc.svg": 1725,
	"./pbb-color.svg": 1726,
	"./pbb.svg": 1727,
	"./pinbidja-color.svg": 1728,
	"./rhb-b.svg": 1729,
	"./rhb-color-b.svg": 1730,
	"./rhb-color.svg": 1731,
	"./rhb.svg": 1732,
	"./scb-color.svg": 1733,
	"./scb.svg": 1734,
	"./tng-color.svg": 1735,
	"./uob-color.svg": 1736,
	"./uob.svg": 1737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;